import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Card,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Button,
  Box,
  Grid,
  Paper,
  IconButton,
  TextField,
  Link,
  CardContent,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import {
  validateCountry,
  validateState,
  validateCity,
  validateStreet,
  validateLandmark,
  validatePincode,
} from "../../utils/textFieldValidations";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useNavigate } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import HomeIcon from "@mui/icons-material/Home";
import WorkIcon from "@mui/icons-material/Business";
import OtherIcon from "@mui/icons-material/Room";
import CloseIcon from "@mui/icons-material/Close";
import { useFetch } from "../../hooks";

import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { styled } from "@mui/system";
import { getCustomerId, getUserLoginNumber } from "../../store/actions/userActions";
import {
  getPrimaryAddress,
  disptchDeliveryMode,
  getSiteSettingsData,
  setFinalPayAmount,
  setSiteSettingsCharges,
  setPlatformFee,
  setDeliveryPartnerFee,
  setGstCharges,
  setcouponAmountData,
} from "../../store/actions/userActions";
import { updateCartTotal } from "../../store/actions/userActions";
import {
  GoogleMap,
  useLoadScript,
  MarkerF,
  InfoWindowF,
} from "@react-google-maps/api";
// redux actions imports

import {
  addToCart,
  removeFromCart,
  updateCartQuantity,
  getCouponCode,
  getCouponAmount,
} from "../../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";

const markerIcon = new L.Icon({
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  shadowSize: [41, 41],
});

const CartPage = () => {
  const changedAddress = useSelector(
    (state) => state.user?.userLocation?.changedAddress ?? null,
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  const StyledButton = styled(Button)({
    background: "linear-gradient(to right, #ff416c, #ff4b2b)",
    color: "#fff",
    padding: "12px 0",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "30px",
    marginTop: "20px",
    textTransform: "none",
    ":hover": {
      background: "linear-gradient(to right, #F4511E, #E64A19)",
    },
  });
  const apptoken = useSelector((state) => state.user.apptoken);
  const dispatch = useDispatch();
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success",
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();
  const [deliveryMode, setDeliveryMode] = useState("home delivery");
  const [showLogin, setShowLogin] = useState(false);
  const [showAddress, setShowAddress] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [saveAdress, setSaveAdress] = useState(false);
  const [saveAdress1, setSaveAdress1] = useState(false);
  const [allowResend, setAllowResend] = useState(false);
  const [location, setLocation] = useState([25.608192, 85.1247104]);
  const [selectedType, setSelectedType] = useState("Home");
  const [isModalOpen, setModalOpen] = useState(false);
  const [couponChecked, setCouponChecked] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);
  const [error, setError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [timer, setTimer] = useState(60);
  const [showOTP, setShowOTP] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const inputRefs = useRef([]);
  const [applyCoupon, setApplyCoupon] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponAmount, setCouponAmount] = useState("");
  const reduxCustomerId = useSelector((state) => state?.user?.customerId);
  const [customerId, setCustomerId] = useState(reduxCustomerId || "");
  const [data, setData] = useState("");

  const cartItemsDetails = useSelector(
    (state) => state.user?.cartDetails || [],
  );

  const cartItems = Array.isArray(cartItemsDetails.items)
    ? cartItemsDetails.items
    : [];

  console.log("cartItems", cartItems);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [customerData, setCustomerData] = useState({
    country: "",
    state: "",
    city: "",
    street: "",
    landmark: "",
    pincode: "",
    latitude: "",
    longitude: "",
    status: "",
    searchlocation: "",
    addressId: "",
    isDefault: false,
  });

  const initializeCustomerData = () => {
    setCustomerData({
      country: "",
      state: "",
      city: "",
      street: "",
      landmark: "",
      pincode: "",
      latitude: customerData.latitude,
      longitude: customerData.longitude,
      status: "",
      searchlocation: "",
      setCustomerData: "",
      addressId: "",
      isDefault: false,
    });
  };
  const [errors, setErrors] = useState({});
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const libraries = ["places"];
  const [isInfoWindowOpen, setInfoWindowOpen] = useState(false);

  const clearErrors = () => {
    setErrors({});
  };
  // Function to handle location search using Google Maps Geocoding API
  const handleLocationSearch = async (e) => {
    const searchValue = e.target.value;

    setCustomerData({
      ...customerData,
      searchlocation: searchValue,
    });
    if (!searchValue || searchValue.trim().length < 3) return;

    const query = `${customerData["city"]}, ${customerData["state"]}, ${customerData["country"]}`;
    console.log("query", query);

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          searchValue,
        )}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
      );

      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;

        setCustomerData((prevData) => ({
          ...prevData,
          latitude: lat,
          longitude: lng,
          searchlocation: searchValue,
        }));

        if (mapRef.current) {
          mapRef.current.setCenter({ lat, lng });
          mapRef.current.setZoom(15);
        }

        if (markerRef.current) {
          markerRef.current.setPosition({ lat, lng });
        }
      } else {
        console.log("No results found.");
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };
  const useGoogleMaps = () => {
    const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8",
      libraries,
    });

    return { isLoaded, loadError };
  };
  const { isLoaded, loadError } = useGoogleMaps();

  const createRedIcon = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      return {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new window.google.maps.Size(40, 40),
      };
    }
    console.log("Google Maps not loaded yet");
    return null;
  };
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setCustomerData((customerData) => ({
          ...customerData,
          latitude: latitude,
          longitude: longitude,
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, [latitude, longitude]);

  const LocationPicker = ({ setLatitude, setLongitude, setLocation }) => {
    const handleMapClick = (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;
          setLatitude(lat);
          setLongitude(lng);
        }
      });
    };
  };

  const handleQuantityChange = (change, item) => {
    console.log("incredecre item", item);
    const newQuantity = item.quantity + change;
    const updatedItem = {
      ...item,
      quantity: newQuantity,
    };
    //dispatch(addToCart({ item: updatedItem }));

    // if (quantity + change > 0) {
    //   setQuantity(quantity + change);
    // }
  };

  const {
    data: createRegisterData,
    isLoading: createRegisterLoading,
    error: createRegisterError,
    fetchData: fetchCreateRegisterData,
  } = useFetch(BASE_URL_TEST + urls("userregister"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: verifyOtpData,
    error: verifyOtpError,
    isLoading: verifyOtpDataLoading,
    fetchData: fetchVerifyOtp,
  } = useFetch(BASE_URL_TEST + urls("verifyotp"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  //get All Address
  const {
    data: addressData,
    isLoading: isaddressLoading,
    error: addressError,
    fetchData: fetchAddressData,
  } = useFetch(BASE_URL_TEST + urls("getAllManageAddress", customerId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: primaryAddress,
    isLoading: primaryAddressLoading,
    error: primaryAddressError,
    fetchData: fetchSetPrimaryAddress,
  } = useFetch(BASE_URL_TEST + urls("setPrimaryAddress"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });
  const {
    data: createAddress,
    isLoading: createAddressLoading,
    error: createAddressError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createAdddressForProfile"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: couponData,
    isLoading: isCouponLoading,
    error: couponError,
    fetchData: fetchCouponData,
  } = useFetch(BASE_URL_TEST + `/api/coupon/all?search=${couponCode}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    fetchSiteSettingsData();
  }, []);

  const {
    data: siteSettingsData,
    isLoading: isSiteSettingsDataLoading,
    error: siteSettingsError,
    fetchData: fetchSiteSettingsData,
  } = useFetch(BASE_URL_TEST + urls("getAdminSiteSettings"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (showOTP && timer > 0) {
      const countdown = setTimeout(
        () => setTimer((prevTimer) => prevTimer - 1),
        1000,
      );
      return () => clearTimeout(countdown);
    } else if (timer === 0) {
      setAllowResend(true);
    }
  }, [showOTP, timer]);

  useEffect(() => {
    if (createRegisterError) {
    } else if (createRegisterData && createRegisterData["status"] === true) {
      const otpFromResponse = createRegisterData?.data?.otp;
      setSnackbarState({
        ...snackbarState,
        message: createRegisterData["message"],
        status: createRegisterData["status"],
      });
      console.log("Received OTP:", otpFromResponse);

      if (otpFromResponse && otpFromResponse.length === 6) {
        setOtp(otpFromResponse.split("")); //for otp automatically setting
      }
      setShowOTP(true);
    } 
     else if (createRegisterData && createRegisterData["status"] === false) {
    setError(createRegisterData["message"]);  
    setShowOTP(false); // ensure OTP screen is not shown
  }
  }, [createRegisterData, createRegisterError]);

  useEffect(() => {
    if (couponError) {
      setCouponAmount("0.00");
      setCouponChecked(true);
    } else if (couponData && couponData.data && couponData.data.length > 0) {
      const discountAmount = couponData?.data[0]?.amount || "0.00";
      console.log("discountAmount", discountAmount);
      setCouponAmount(discountAmount);
      setCouponChecked(true);

      const updatedOrderData = {
        ...cartItemsDetails,
        // finalPay: cartItemsDetails.total + 8 - Number(discountAmount || 0),
        finalPay:
          cartItemsDetails.total +
          Number(data?.platform_fee || 0) +
          Number(data?.delivery_partner_fee || 0) +
          gstAmount -
          Number(discountAmount || 0),
      };

      console.log("updatedOrderData", updatedOrderData);

      dispatch(addToCart({ item: updatedOrderData, modification: true }));
      dispatch(getCouponCode(couponData?.data[0]?.coupon_code));
      dispatch(getCouponAmount(couponData?.data[0]?.amount));
    } else if (
      couponData &&
      couponData?.data &&
      couponData?.data?.length === 0
    ) {
      console.log("Invalid coupon");
      setCouponAmount("0.00");
      setCouponChecked(true);
    }
  }, [couponData, couponError]);

  //   useEffect(() => {
  //   if (cartItemsDetails) {
  //     const subtotal = Number(cartItemsDetails.total) || 0;
  //     const shippingFee = 8;
  //     const discount = Number(couponAmount || 0);

  //     const totalToPay = subtotal + shippingFee - discount;

  //     dispatch(addToCart({
  //       items: cartItemsDetails.items || [],
  //       subtotal,
  //       shipping: shippingFee,
  //       discount,
  //       finalPay: totalToPay
  //     }));
  //   }
  // }, [cartItemsDetails, couponAmount, dispatch]);

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("").trim();
    if (otp.some((digit) => digit.trim() === "")) {
      setOtpError("OTP is required");
    } else {
      console.log("OTP entered:", otp.join(""));
      setOtpError("");
    }
    const otpRegex = /^\d{6}$/;
    if (!otpRegex.test(enteredOtp)) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }
    setOtpError("");

    const requestData = {
      phone_number: mobileNumber,
      otp: enteredOtp,
      device_type: "web",
    };

    try {
      await fetchVerifyOtp(requestData);
    } catch (error) {
      console.error("OTP verification failed:", error);
      setOtpError("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    if (verifyOtpError) {
      setOtpError("Something went wrong while verifying OTP.");
    } else if (verifyOtpData && verifyOtpData["status"] === true) {
      console.log("OTP verification successful. ID:", verifyOtpData?.data?.id);
      setCustomerId(verifyOtpData?.data?.id);
      dispatch(getCustomerId(verifyOtpData?.data?.id));
      setShowAddress(true);
      setShowLogin(false);
      setShowOTP(false);
        dispatch(getUserLoginNumber({ mobile_number: mobileNumber }));
    } else if (verifyOtpData && verifyOtpData["status"] === false) {
      setOtpError(verifyOtpData["message"]);
    }
  }, [verifyOtpData, verifyOtpError]);

  useEffect(() => {
    if (customerId) {
      fetchAddressData(BASE_URL_TEST + urls("getAllManageAddress", customerId));
    }
  }, [customerId]);

  useEffect(() => {
    if (addressError) {
    } else if (addressData && addressData["status"] === true) {
      setAddressList(addressData["data"]);
    }
  }, [addressData, addressError]);

  //Create Address
  useEffect(() => {
    if (createAddressError) {
    } else if (createAddress && createAddress["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createAddress["message"],
        status: createAddress["status"],
      });
      setModalOpen(true);
      fetchAddressData();
    } else if (createAddress && createAddress["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createAddress["message"],
        status: createAddress["status"],
      });
      setModalOpen(true);
      fetchAddressData();
    }
  }, [createAddress, createAddressError]);

  const handleCloseAddress = () => {
    setModalOpen(false);
    clearErrors();

    if (createAddress && createAddress["status"] === true) {
      initializeCustomerData();
      setCustomerData({
        latitude: "",
        longitude: "",
      });
      setIsAddModalOpen(false);
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };
  const platformFee = Number(data?.platform_fee || 0);
  const deliveryPartnerFee = Number(data?.delivery_partner_fee || 0);
  const [gstAmount, setGstAmount] = useState(0);
  // const gstAmount =
  //   ((cartItemsDetails?.total || 0) * Number(data?.gst_charge || 0)) / 100;
  const gstCharges = gstAmount;
  const couponAmountData = Number(couponAmount || 0);

useEffect(() => {
  if (siteSettingsData && siteSettingsData["status"] === true) {
    const settings = siteSettingsData["data"];
    setData(settings);

    const platform  = Number(settings?.platform_fee || 0);
    const delivery  = Number(settings?.delivery_partner_fee || 0);
    const gstRate   = Number(settings?.gst_charge || 0);

    const calculatedGst = ((platform + delivery) * gstRate) / 100;

    setGstAmount(calculatedGst);

    dispatch(getSiteSettingsData(settings));
    dispatch(setPlatformFee(platform));
    dispatch(setDeliveryPartnerFee(delivery));
    dispatch(setGstCharges(calculatedGst));
    dispatch(setcouponAmountData(Number(couponAmount || 0)));
  }
}, [siteSettingsData, siteSettingsError]);

  const finalAmount =
    (cartItemsDetails?.total || 0) +
    Number(data?.platform_fee || 0) +
    Number(data?.delivery_partner_fee || 0) +
    gstAmount -
    Number(couponAmount || 0);

  const siteSettingsFees =
    Number(data?.platform_fee || 0) +
    Number(data?.delivery_partner_fee || 0) +
    gstAmount -
    Number(couponAmount || 0);

  useEffect(() => {
    dispatch(setFinalPayAmount(finalAmount.toFixed(2)));
  }, [finalAmount]);

  useEffect(() => {
    dispatch(setSiteSettingsCharges(siteSettingsFees.toFixed(2)));
  }, [siteSettingsFees]);

  const handleSetDefaultAddress = (addressId) => {
    const updatedAddresses = addressList.map((address) => ({
      ...address,
      is_primary: address.address_id === addressId ? 1 : 0,
    }));

    setAddressList(updatedAddresses);

    const setPrimaryAddress = {
      user_id: customerId,
      address_id: addressId,
    };
    fetchSetPrimaryAddress(setPrimaryAddress);
  };
  useEffect(() => {
    if (primaryAddressError) {
    } else if (primaryAddress && primaryAddress["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: primaryAddress["message"],
        status: primaryAddress["status"],
      });
    } else if (primaryAddress && primaryAddress["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: primaryAddress["message"],
        status: primaryAddress["status"],
      });
    }
  }, [primaryAddress, primaryAddressError]);

  const primaryAddressData = addressList?.find((addr) => addr.is_primary === 1);
  dispatch(getPrimaryAddress(primaryAddressData));

  const handleLogin = () => {
    const trimmedMobile = mobileNumber.trim();
    const regex = /^[6-9]\d{9}$/;

    if (!trimmedMobile) {
      setError("Mobile number is required.");
      return;
    } else if (!regex.test(trimmedMobile)) {
      setError("Enter a valid 10-digit mobile number");
      return;
    }
    const saveBody = {
      phone_number: mobileNumber,
      device_type: "web",
      firebase_device_token:""
    };
    fetchCreateRegisterData(saveBody);
  };

  const resendOtp = () => {
    setOtp(["", "", "", "", "", ""]);
    setTimer(60);
    setAllowResend(false);

    setOtpError("");
    inputRefs.current[0].focus();
    const saveBody = {
      phone_number: mobileNumber,
      device_type: "web",
    };
    fetchCreateRegisterData(saveBody);
  };

  const handleSaveAddress = () => {
    let validationErrors = {};
    if (!validateCountry(customerData.country)) {
      validationErrors.country =
        "Country is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateState(customerData.state)) {
      validationErrors.state =
        "State is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }
    if (!validateCity(customerData.city)) {
      validationErrors.city =
        "City is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }
    if (!validateStreet(customerData.street)) {
      validationErrors.street =
        "Street is required and can contain letters, numbers, spaces, commas, periods, hyphens, and hashes..";
      setErrors(validationErrors);
      return;
    }

    if (!validateLandmark(customerData.landmark)) {
      validationErrors.landmark = "Landmark is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePincode(customerData.pincode)) {
      validationErrors.pincode = "Pincode should be a 6-digit number.";
      setErrors(validationErrors);
      return;
    }
    if (!customerData?.isDefault) {
      validationErrors.isDefault =
        "Mark this as your default address to proceed.";
      setErrors(validationErrors);
      return;
    }
    if (!validateLandmark(customerData.searchlocation)) {
      validationErrors.searchlocation = "Location is required.";
      setErrors(validationErrors);
      return;
    }
    clearErrors();

    const saveBody = {
      user_id: customerId,
      is_primary: customerData?.isDefault ? 1 : 0,
      country: customerData?.country,
      state: customerData?.state,
      city: customerData?.city,
      street: customerData?.street,
      landmark: customerData?.landmark,
      pincode: customerData?.pincode,
      latitude: customerData?.latitude,
      longitude: customerData?.longitude,
    };
    fetchCreateData(saveBody);
  };

const increaseItem = (item) => {
  const id = item.vendor_product_id || item.product_id; // use the right one
  const newQuantity = item.quantity + 1;
  dispatch(updateCartQuantity(id, newQuantity));
};

const decreaseItem = (item) => {
  const id = item.vendor_product_id || item.product_id;
  if (item.quantity > 1) {
    dispatch(updateCartQuantity(id, item.quantity - 1));
  } else {
    dispatch(removeFromCart(id));
  }
};

  const handleRemoveItem = (item) => {
    dispatch(removeFromCart(item.vendor_product_id));
  };
  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };
  const handleChangeDelieryMode = (e) => {
    const mode = e.target.value;
    setDeliveryMode(e.target.value);
    dispatch(disptchDeliveryMode(mode));
  };

  const handleClick = () => {
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        paddingTop: 2,
        px: { xs: 1.5, sm: 2, md: 3 },
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="back"
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" sx={{ marginLeft: 1, fontWeight: "bold" }}>
          Your Cart
        </Typography>
      </Box>

      {/* Delivery Mode */}
      {cartItems && Array.isArray(cartItems) && cartItems.length > 0 ? (
        <Card sx={{ marginBottom: 2, padding: 2, backgroundColor: "#fff6f2" }}>
          <Typography
            variant="h6"
            sx={{ color: "#e67e22", fontWeight: "bold", fontSize: "1.2rem" }}
          >
            Choose Delivery Mode
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup value={deliveryMode} onChange={handleChangeDelieryMode}>
              <FormControlLabel
                value="home delivery"
                control={<Radio color="error" />}
                label="Delivery to Home"
              />
              <FormControlLabel
                value="self pickup"
                control={<Radio color="error" />}
                label="Self Pick Up"
              />
            </RadioGroup>
          </FormControl>
        </Card>
      ) : null}

      {/* Review Your order un modified */}
      {/*commented on 13-09-25 duplicate code*/}
      {/* <Card
        sx={{
          marginBottom: 2,
          padding: 2,
          backgroundColor: "#fff6f2",
          display: "none",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            variant="h6"
            sx={{ color: "#e67e22", fontWeight: "bold", fontSize: "1.2rem" }}
          >
            Review your orders
          </Typography>
          <Button
            variant="outlined"
            color="error"
            sx={{ fontWeight: "bold", textTransform: "none" }}
            onClick={handleClick}
          >
            Add More Items
          </Button>
        </Box>
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          sx={{ marginBottom: 1 }}
        >
        </Typography>
        <Divider />

        {cartItems && Array.isArray(cartItems) && cartItems.length > 0 ? (
          cartItems.map((item, index) => (
            <Grid
              container
              key={index}
              spacing={2}
              alignItems="center"
              sx={{ my: 2, p: 2, backgroundColor: "#fff7f7", borderRadius: 2 }}
            >
              <Grid item xs={12} sm={2}>
                <Box
                  component="img"
                  src={item.images[0]}
                  alt={item.title}
                  sx={{
                    width: "100%",
                    height: "auto",
                    maxHeight: 120,
                    objectFit: "contain",
                    borderRadius: 1,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  1 kg
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexDirection={{ xs: "column", sm: "row" }}
                >
                  <Box textAlign={{ xs: "center", sm: "right" }}>
                    <Typography
                      variant="body2"
                      sx={{ textDecoration: "line-through", color: "grey" }}
                    >
                      ₹{item.originalPrice || item.price}
                    </Typography>
                    <Typography variant="h6" fontWeight="bold">
                      ₹{item.price}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" mt={{ xs: 1, sm: 0 }}>
                    <Button
                      variant="outlined"
                      color="success"
                      size="small"
                      onClick={() => handleQuantityChange(-1, index)}
                      sx={{ minWidth: "36px" }}
                    >
                      <RemoveIcon fontSize="small" />
                    </Button>
                    <Typography variant="body1" mx={1}>
                      {item.quantity || 1}
                    </Typography>
                    <Button
                      variant="outlined"
                      color="success"
                      size="small"
                      onClick={() => handleQuantityChange(1, index)}
                      sx={{ minWidth: "36px" }}
                    >
                      <AddIcon fontSize="small" />
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          ))
        ) : (
          <Typography variant="h6" textAlign="center" mt={4}>
            Your cart is empty.
          </Typography>
        )}

        <Box display="none" justifyContent="center" sx={{ marginTop: 1 }}>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={() => handleQuantityChange(-1)}
            sx={{ minWidth: "40px" }}
          >
            <RemoveIcon />
          </Button>
          <Typography variant="h6" sx={{ marginX: 2 }}>
            {quantity}
          </Typography>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={() => handleQuantityChange(1)}
            sx={{ minWidth: "40px" }}
          >
            <AddIcon />
          </Button>
        </Box>
      </Card> */}

      {/* Review your order modified */}
      <Card sx={{ marginBottom: 2, padding: 2, backgroundColor: "#fff6f2" }}>
        {/* Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography
            variant="h6"
            sx={{ color: "#e67e22", fontWeight: "bold", fontSize: "1.2rem" }}
          >
            Review your orders
          </Typography>
          <Button
            variant="outlined"
            color="error"
            sx={{ fontWeight: "bold", textTransform: "none" }}
            onClick={handleClick}
          >
            Add More Items
          </Button>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Scrollable Cart Items */}
        <Box sx={{ maxHeight: 300, overflowY: "auto", pr: 1 }}>
          {cartItems && Array.isArray(cartItems) && cartItems.length > 0 ? (
            cartItems.map((item, index) => (
              <Box
                key={index}
                sx={{
                  position: "relative",
                  my: 1,
                  p: 2,
                  backgroundColor: "#fff7f7",
                  borderRadius: 2,
                }}
              >
                {/* Remove (Close) Button */}
                <IconButton
                  size="small"
                  onClick={() => handleRemoveItem(item)}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    color: "#ff5252",
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>

                {/* Main Content */}
                <Grid container spacing={2} alignItems="center">
                  {/* Product Image */}
                  <Grid item xs={12} sm={2}>
                    <Box
                      component="img"
                      src={item.images[0]}
                      alt={item.title}
                      sx={{
                        width: "100%",
                        height: "auto",
                        maxHeight: 100,
                        objectFit: "contain",
                        borderRadius: 1,
                      }}
                    />
                  </Grid>

                  {/* Product Info */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {item.title}
                    </Typography>

                    <Typography variant="body1">
                      Variant:{" "}
                      {item.selectedVariants?.length > 0
                        ? item.selectedVariants.map((variant, index) => (
                            <span key={variant.variant_id}>
                              {variant.option_name}
                              {index < item.selectedVariants.length - 1 && ", "}
                            </span>
                          ))
                        : "--"}
                    </Typography>
                  </Grid>

                  {/* Price & Quantity */}
                  <Grid item xs={12} sm={4}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexDirection={{ xs: "column", sm: "row" }}
                    >
                      <Box textAlign={{ xs: "center", sm: "right" }}>
                        <Typography
                          variant="body2"
                          sx={{ textDecoration: "line-through", color: "grey" }}
                        >
                          ₹{item.originalPrice || item.price}
                        </Typography>
                        <Typography variant="h6" fontWeight="bold">
                          ₹{item.price}
                        </Typography>
                      </Box>

                      {/* Quantity increements */}
                      <Box
                        display="flex"
                        alignItems="center"
                        mt={{ xs: 1, sm: 0 }}
                      >
                        <Button
                          variant="outlined"
                          color="success"
                          size="small"
                          onClick={() => decreaseItem(item)}
                          sx={{ minWidth: "36px" }}
                        >
                          <RemoveIcon fontSize="small" />
                        </Button>
                        <Typography variant="body1" mx={1}>
                          {/* {item.quantity || 1} */}
                          {item.quantity}
                        </Typography>
                        <Button
                          variant="outlined"
                          color="success"
                          size="small"
                          onClick={() => increaseItem(item)}
                          sx={{ minWidth: "36px" }}
                        >
                          <AddIcon fontSize="small" />
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            ))
          ) : (
            <Typography variant="h6" textAlign="center" mt={2}>
              Your cart is empty.
            </Typography>
          )}
        </Box>
      </Card>

      {/* Bill Details */}
      {cartItems && Array.isArray(cartItems) && cartItems.length > 0 ? (
        <Card sx={{ marginBottom: 2, padding: 2, backgroundColor: "#fff6f2" }}>
          <Typography
            variant="h6"
            sx={{ color: "#e67e22", fontWeight: "bold", fontSize: "1.2rem" }}
          >
            Bill Details
          </Typography>
          <Box sx={{ marginTop: 1 }}>
            {[
              [
                "MRP Total",
                cartItemsDetails ? cartItemsDetails.total.toFixed(2) : "0.00",
              ],
              ["Items and Savings", "0"],
              [
                "Handling Fee",
                data?.platform_fee
                  ? Number(data.platform_fee).toFixed(2)
                  : "0.00",
              ],
              [
                "Delivery Partner Fee",
                data?.delivery_partner_fee
                  ? Number(data.delivery_partner_fee).toFixed(2)
                  : "0.00",
              ],
             [
  `GST and Charges (${Number(data?.gst_charge || 0)}%) on fees`,
  gstAmount.toFixed(2),
],
            ].map(([label, value], index) => (
              <Box display="flex" justifyContent="space-between" key={index}>
                <Typography variant="body2">{label}</Typography>
                <Typography variant="body2">₹ {value}</Typography>
              </Box>
            ))}
            <Box mt={2}>
              <Box display="flex" alignItems="center">
                <Checkbox
                  checked={applyCoupon}
                  onChange={(e) => setApplyCoupon(e.target.checked)}
                />
                <Typography variant="body2">Apply Coupon</Typography>
              </Box>
              {applyCoupon && (
                <Box mt={1} display="flex" gap={1} alignItems="center">
                  <TextField
                    size="small"
                    label="Enter Coupon Code"
                    variant="outlined"
                    value={couponCode}
                    onChange={(e) => {
                      setCouponCode(e.target.value);
                      setCouponChecked(false);
                      setCouponApplied(false);
                    }}
                  />
                  {couponChecked && Number(couponAmount || 0) === 0 ? (
                    <Typography
                      variant="body2"
                      sx={{ ml: 1, color: "red", fontWeight: "bold" }}
                    >
                      No coupon available
                    </Typography>
                  ) : couponChecked && Number(couponAmount || 0) > 0 ? (
                    <Typography
                      variant="body2"
                      sx={{ ml: 1, color: "green", fontWeight: "bold" }}
                    >
                      Coupon Amount: ₹ {couponAmount}
                    </Typography>
                  ) : null}

                  <Button
                    variant="contained"
                    disabled={!couponCode || couponApplied}
                    onClick={() => {
                      fetchCouponData(couponCode);
                      setCouponApplied(true);
                      console.log("Coupon applied:", couponCode);
                    }}
                  >
                    Apply
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
          <Divider sx={{ marginY: 2 }} />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              To Pay
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              ₹
              {(
                (cartItemsDetails?.total || 0) +
                Number(data?.platform_fee || 0) +
                Number(data?.delivery_partner_fee || 0) +
                gstAmount -
                Number(couponAmount || 0)
              ).toFixed(2)}
            </Typography>
          </Box>
        </Card>
      ) : null}

      {/* Note and Proceed Button */}
      {cartItems && Array.isArray(cartItems) && cartItems.length > 0 ? (
        <>
          <Typography variant="body2" sx={{ color: "grey" }}>
            Review your order to avoid cancellations
          </Typography>
          <Typography variant="body2" sx={{ color: "red", fontWeight: "bold" }}>
            Note: Orders cannot be cancelled and are non-refundable once packed
            for delivery.
          </Typography>
          {!showLogin && !showAddress && !customerId ? (
            <>
              {/* Back Button */}
              <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="back"
                  onClick={() => console.log("Navigate back")}
                >
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  variant="h6"
                  sx={{ marginLeft: 1, fontWeight: "bold", fontSize: "1.2rem" }}
                >
                  Your Cart
                </Typography>
              </Box>
              {/* Existing Cart Content */}
              <Paper
                sx={{
                  padding: 2,
                  marginTop: 2,
                  backgroundColor: "#f9f9f9",
                  marginBottom: 4,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: "#3498db", fontWeight: "bold" }}
                >
                  Almost There
                </Typography>
                <Typography variant="body2">
                  Login or Register to place your order
                </Typography>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    marginTop: 2,
                    backgroundColor: "#e74c3c",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                  onClick={() => setShowLogin(true)}
                >
                  Proceed with phone number
                </Button>
              </Paper>
            </>
          ) : showLogin && !showAddress ? (
            <>
              {/* Login UI */}
              <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="back"
                  onClick={() => setShowLogin(false)}
                >
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  variant="h6"
                  sx={{ marginLeft: 1, fontWeight: "bold" }}
                >
                  Almost There
                </Typography>
              </Box>
              <Typography variant="body2">
                Login or Register to place your order
              </Typography>
              <Card
                sx={{ padding: 2, marginBottom: 2, backgroundColor: "#f9f9f9" }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", marginBottom: 1 }}
                >
                  Phone number
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="+91 92****21"
                  value={mobileNumber}
                  onChange={(e) => {
  setMobileNumber(e.target.value);
  setError(""); // ✅ clear error on new input
}}
                  sx={{ marginBottom: 2 }}
                />
                {error && (
                  <Typography
                    color="error"
                    fontSize="10"
                    mt={1}
                    alignSelf={"flex-start"}
                  >
                    {error}
                  </Typography>
                )}
                {!showOTP && (
                  <StyledButton fullWidth onClick={handleLogin}>
                    Continue
                  </StyledButton>
                )}
                {/* OTP Section */}
                {showOTP && (
                  <>
                    <IconButton
                      onClick={() => setShowOTP(false)}
                      sx={{ alignSelf: "flex-start", color: "white" }}
                    >
                      <ArrowBackIcon />
                    </IconButton>

                    <Typography variant="h4" fontWeight="bold">
                      OTP Verification
                    </Typography>
                    <Typography>
                      OTP has been sent to <b>{mobileNumber}</b>
                    </Typography>

                    <Box mt={3} display="flex" gap={1}>
                      {otp.map((digit, index) => (
                        <TextField
                          key={index}
                          value={digit}
                          inputRef={(el) => (inputRefs.current[index] = el)}
                          variant="outlined"
                          sx={{
                            width: 50,
                            background: "white",
                            borderRadius: "8px",
                          }}
                          inputProps={{
                            maxLength: 1,
                            style: { textAlign: "center" },
                          }}
                          onChange={(e) => handleChange(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                        />
                      ))}
                    </Box>

                    {otpError && (
                      <Box mt={1} alignSelf={"flex-start"}>
                        <Typography color="error" variant="body2">
                          {otpError}
                        </Typography>
                      </Box>
                    )}

                    {!allowResend ? (
                      <Typography mt={2} fontSize={20}>
                        00:{timer < 10 ? `0${timer}` : timer}
                      </Typography>
                    ) : (
                      <Link
                        href="#"
                        sx={{ color: "#FF6D91", fontWeight: "bold", mt: 1 }}
                        onClick={resendOtp}
                      >
                        Resend OTP
                      </Link>
                    )}

                    <StyledButton fullWidth onClick={handleVerifyOtp}>
                      Submit
                    </StyledButton>
                  </>
                )}
              </Card>
              <Typography
                variant="body2"
                sx={{ textAlign: "center", color: "grey", marginTop: 1 }}
              >
                By clicking on Login, I accept the Terms & Conditions & Privacy
                Policy
              </Typography>
            </>
          ) : (
            <>
              {/* Address UI */}

              {showAddress && customerId && (
                <>
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{ marginBottom: 2 }}
                  >
                    <IconButton
                      edge="start"
                      color="inherit"
                      aria-label="back"
                      onClick={() => {
                        setShowAddress(false);
                        setShowLogin(true);
                      }}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                    <Typography
                      variant="h6"
                      sx={{ marginLeft: 1, fontWeight: "bold" }}
                    >
                      Back
                    </Typography>
                  </Box>
                  {/* <Paper sx={{ padding: 2, backgroundColor: "#f9f9f9" }}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#e67e22",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <LocationOnIcon sx={{ marginRight: 1 }} />
                  Home Delivery
                </Typography>
                <Typography variant="body2">
                  {changedAddress}
                </Typography>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    marginTop: 2,
                    backgroundColor: "#e74c3c",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setShowMap(true);
                    console.log("Location Confirmed");
                  }}
                >
                  Add Address to Proceed
                </Button>
              </Paper> */}
                  {/* <Grid container spacing={2}>
                          {addressList.map((address) => (
                            <Grid item xs={12} sm={6} key={address.address_id}>
                              <Card
                                sx={{
                                  p: 2,
                                  borderRadius: 2,
                                  border: "1px solid #e0e0e0",
                                }}
                              >
                                <CardContent>
                                  <Typography variant="subtitle1" fontWeight={600}>
                                    {address.street}, {address.city}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    Landmark: {address.landmark}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    {address.state}, {address.country} - {address.pincode}
                                  </Typography>
              
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={address.is_primary === 1}
                                        onChange={() =>
                                          handleSetDefaultAddress(address.address_id)
                                        }
                                        color="primary"
                                      />
                                    }
                                    label="Default Address"
                                    sx={{ mt: 1 }}
                                  />
                                </CardContent>
                              </Card>
                            </Grid>
                          ))}
                        </Grid> */}
                </>
              )}

              {customerId && addressList?.length > 0 ? (
                <Grid container spacing={2}>
                  {addressList.map((address) => (
                    <Grid item xs={12} sm={6} key={address.address_id}>
                      <Card
                        sx={{
                          p: 2,
                          borderRadius: 2,
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <CardContent>
                          <Typography variant="subtitle1" fontWeight={600}>
                            {address.street}, {address.city}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Landmark: {address.landmark}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {address.state}, {address.country} -{" "}
                            {address.pincode}
                          </Typography>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={address.is_primary === 1}
                                onChange={() =>
                                  handleSetDefaultAddress(address.address_id)
                                }
                                color="primary"
                              />
                            }
                            label="Default Address"
                            sx={{ mt: 1 }}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  <Typography variant="body1" color="text.secondary">
                    No addresses found.
                  </Typography>

                  <Button
                    variant="contained"
                    sx={{
                      background: "#FB4923",
                      borderRadius: "8px",
                      padding: "10px 24px",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                    onClick={() => setIsAddModalOpen(true)}
                  >
                    Add Address
                  </Button>
                </Box>
              )}
              {/* Add Address Dialog */}
              <Dialog
                open={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
                fullWidth
                maxWidth={false}
                sx={{
                  "& .MuiDialog-paper": {
                    width: "95%",
                    height: "95vh",
                    maxWidth: "none",
                    maxHeight: "none",
                  },
                }}
              >
                <DialogTitle>Add New Address</DialogTitle>
                <DialogContent>
                  <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                    <TextField
                      margin="dense"
                      label="Country"
                      fullWidth
                      value={customerData?.country || ""}
                      onChange={(e) =>
                        setCustomerData({
                          ...customerData,
                          country: e.target.value,
                        })
                      }
                      error={!!errors.country}
                      helperText={
                        errors.country && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                              fontSize: 12,
                            }}
                          >
                            {errors.country}
                          </Typography>
                        )
                      }
                    />
                    <TextField
                      margin="dense"
                      label="State"
                      fullWidth
                      value={customerData?.state || ""}
                      onChange={(e) =>
                        setCustomerData({
                          ...customerData,
                          state: e.target.value,
                        })
                      }
                      error={!!errors.state}
                      helperText={
                        errors.state && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                              fontSize: 12,
                            }}
                          >
                            {errors.state}
                          </Typography>
                        )
                      }
                    />
                    <TextField
                      margin="dense"
                      label="City"
                      fullWidth
                      value={customerData?.city || ""}
                      onChange={(e) =>
                        setCustomerData({
                          ...customerData,
                          city: e.target.value,
                        })
                      }
                      error={!!errors.city}
                      helperText={
                        errors.city && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                              fontSize: 12,
                            }}
                          >
                            {errors.city}
                          </Typography>
                        )
                      }
                    />
                  </Box>
                  <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                    <TextField
                      margin="dense"
                      label="Street"
                      fullWidth
                      value={customerData?.street || ""}
                      onChange={(e) =>
                        setCustomerData({
                          ...customerData,
                          street: e.target.value,
                        })
                      }
                      error={!!errors.street}
                      helperText={
                        errors.street && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                              fontSize: 12,
                            }}
                          >
                            {errors.street}
                          </Typography>
                        )
                      }
                    />
                    <TextField
                      margin="dense"
                      label="Landmark"
                      fullWidth
                      value={customerData?.landmark || ""}
                      onChange={(e) =>
                        setCustomerData({
                          ...customerData,
                          landmark: e.target.value,
                        })
                      }
                      error={!!errors.landmark}
                      helperText={
                        errors.landmark && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                              fontSize: 12,
                            }}
                          >
                            {errors.landmark}
                          </Typography>
                        )
                      }
                    />
                    <TextField
                      margin="dense"
                      label="Pincode"
                      fullWidth
                      value={customerData?.pincode || ""}
                      onChange={(e) =>
                        setCustomerData({
                          ...customerData,
                          pincode: e.target.value,
                        })
                      }
                      error={!!errors.pincode}
                      helperText={
                        errors.pincode && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                              fontSize: 12,
                            }}
                          >
                            {errors.pincode}
                          </Typography>
                        )
                      }
                    />
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mt: 3 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={customerData?.isDefault || false}
                          onChange={(e) =>
                            setCustomerData({
                              ...customerData,
                              isDefault: e.target.checked,
                            })
                          }
                          color="primary"
                        />
                      }
                      label="Make this as default address"
                    />
                    {errors.isDefault && (
                      <Typography sx={{ color: "red", fontSize: 12 }}>
                        {errors.isDefault}
                      </Typography>
                    )}
                  </Box>

                  {/* Location Search */}
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="h6">Select Location</Typography>
                    <TextField
                      fullWidth
                      margin="dense"
                      label="Search Location"
                      variant="outlined"
                      sx={{ mt: 2 }}
                      value={customerData?.searchlocation}
                      onChange={handleLocationSearch}
                      error={!!errors.searchlocation}
                      helperText={
                        errors.searchlocation && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                              fontSize: 12,
                            }}
                          >
                            {errors.searchlocation}
                          </Typography>
                        )
                      }
                    />

                    {/* Map Component */}
                    {isLoaded ? (
                      <Box>
                        <GoogleMap
                          ref={mapRef}
                          onLoad={(map) => {
                            mapRef.current = map;
                            if (
                              customerData.latitude &&
                              customerData.longitude
                            ) {
                              map.panTo({
                                lat: parseFloat(customerData.latitude),
                                lng: parseFloat(customerData.longitude),
                              });
                              map.setZoom(15);
                            }
                          }}
                          center={{
                            lat: parseFloat(customerData.latitude) || 0,
                            lng: parseFloat(customerData.longitude) || 0,
                          }}
                          zoom={13}
                          mapContainerStyle={{
                            height: "400px",
                            width: "100%",
                            marginTop: "20px",
                          }}
                          options={{
                            streetViewControl: false,
                            mapTypeControl: false,
                          }}
                        >
                          <LocationPicker
                            setLatitude={(lat) =>
                              setCustomerData((prevData) => ({
                                ...prevData,
                                latitude: lat,
                              }))
                            }
                            setLongitude={(lon) =>
                              setCustomerData((prevData) => ({
                                ...prevData,
                                longitude: lon,
                              }))
                            }
                          />
                          {customerData.latitude && customerData.longitude && (
                            <MarkerF
                              ref={markerRef}
                              position={{
                                lat: parseFloat(customerData.latitude),
                                lng: parseFloat(customerData.longitude),
                              }}
                              draggable={true}
                              onDragEnd={async (event) => {
                                const lat = event.latLng.lat();
                                const lng = event.latLng.lng();

                                try {
                                  const response = await fetch(
                                    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
                                  );

                                  const data = await response.json();

                                  if (data.results && data.results.length > 0) {
                                    const newAddress =
                                      data.results[0].formatted_address;

                                    setCustomerData((prev) => ({
                                      ...prev,
                                      latitude: lat,
                                      longitude: lng,
                                      searchlocation: newAddress,
                                    }));
                                  }
                                } catch (error) {
                                  console.error(
                                    "Reverse geocode error:",
                                    error,
                                  );
                                }
                              }}
                              icon={createRedIcon()}
                              onClick={() => setInfoWindowOpen(true)}
                            >
                              {isInfoWindowOpen && (
                                <InfoWindowF
                                  position={{
                                    lat: parseFloat(customerData.latitude),
                                    lng: parseFloat(customerData.longitude),
                                  }}
                                  onCloseClick={() => setInfoWindowOpen(false)}
                                >
                                  <div>
                                    <p>
                                      Latitude: {customerData.latitude},
                                      Longitude: {customerData.longitude}
                                    </p>
                                  </div>
                                </InfoWindowF>
                              )}
                            </MarkerF>
                          )}
                        </GoogleMap>
                      </Box>
                    ) : (
                      <Typography>Loading map...</Typography>
                    )}

                    {/* Latitude & Longitude display */}
                    <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                      <TextField
                        margin="dense"
                        label="Latitude"
                        fullWidth
                        value={customerData?.latitude}
                        InputProps={{ readOnly: true }}
                      />
                      <TextField
                        margin="dense"
                        label="Longitude"
                        fullWidth
                        value={customerData?.longitude || ""}
                        InputProps={{ readOnly: true }}
                      />
                    </Box>
                  </Box>
                </DialogContent>

                {/* Actions */}
                <DialogActions>
                  <Button
                    onClick={() => setIsAddModalOpen(false)}
                    color="secondary"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      background: "#FB4923",
                      borderRadius: "8px",
                      padding: "10px 24px",
                      textTransform: "none",
                      fontWeight: 600,
                      boxShadow: "0px 4px 10px rgba(251, 73, 35, 0.3)",
                      "&:hover": { background: "#E03A18" },
                    }}
                    onClick={handleSaveAddress}
                  >
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Success/Error Modal */}
              <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
                <DialogTitle>
                  {snackbarState.status === true ? "Success" : "Error"}
                </DialogTitle>
                <DialogContent>
                  <Typography
                    variant="body1"
                    sx={{
                      color: snackbarState.status === true ? "green" : "red",
                    }}
                  >
                    {snackbarState.message}
                  </Typography>
                </DialogContent>
                <DialogActions
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCloseAddress}
                    sx={{ textTransform: "none", borderRadius: 2 }}
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>

              {addressList && primaryAddressData && (
                <>
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{ marginBottom: 2 }}
                  >
                    <IconButton
                      edge="start"
                      color="inherit"
                      aria-label="back"
                      onClick={() => {
                        setSaveAdress1(false);
                        setSaveAdress(true);
                      }}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                    <Typography
                      variant="h6"
                      sx={{ marginLeft: 1, fontWeight: "bold" }}
                    >
                      Back
                    </Typography>
                  </Box>
                  <Paper sx={{ padding: 2, backgroundColor: "#f9f9f9" }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#e67e22",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <LocationOnIcon sx={{ marginRight: 1 }} />
                      Home Delivery
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#6c757d",
                          fontStyle: "italic",
                          fontWeight: "bold",
                        }}
                      >
                        (If you want to add more addresses, go to the Account
                        section and add address)
                      </Typography>
                    </Typography>

                    <Typography variant="body2">
                      {primaryAddressData?.street}, {primaryAddressData?.city},{" "}
                      {primaryAddressData?.landmark},{primaryAddressData?.state}
                      , {primaryAddressData?.country} -{" "}
                      {primaryAddressData?.pincode}.
                    </Typography>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{
                        marginTop: 2,
                        backgroundColor: "#e74c3c",
                        fontWeight: "bold",
                        marginBottom: 5,
                        textTransform: "none",
                      }}
                      onClick={() => navigate("/payment")}
                    >
                      Proceed to Payment
                    </Button>
                  </Paper>
                </>
              )}
            </>
          )}
        </>
      ) : null}
    </Container>
  );
};

export default CartPage;
